import { render, staticRenderFns } from "./YezzaPackingSlips.vue?vue&type=template&id=db089768&scoped=true&lang=pug&"
import script from "./YezzaPackingSlips.vue?vue&type=script&lang=js&"
export * from "./YezzaPackingSlips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db089768",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
